module.exports = __webpack_public_path__ + "static/media/complete_rest.4ae5331e.svg";